import styled from '@emotion/styled'
import { Container, Grid } from '@mui/material'
import React from 'react'
import { SectionHeading, SectionWrapper } from '../../../Styles/style'
import ethmainnet from "../../../../assets/images/ethmainnet.png"
import polygon from "../../../../assets/images/polygon.png"
import avalaunche from "../../../../assets/images/avalaunche.png"
import binance from "../../../../assets/images/binance.png"
import shibarium from "../../../../assets/images/shibarium.png"

const PartnerWrapper = styled.div`
display: flex;
justify-content: center;
@media screen and (max-width:599px){
    justify-content: unset;  
}
`
const InnerWrapper = styled.div`
background-color:  ${(props) => props.theme.bgPrimary};
padding: 8px 20px;
border-radius: 20px;
box-shadow : ${(props) => (props.theme.BoxShadowPrimary)};
min-height: 93px;
align-items: center;
display: flex;
`
const ParnterImg = styled.img`
width: 100%;
max-width: ${(props) => (props.mw ? props.mw : "250px")};

@media screen and (max-width:599px){
    max-width: ${(props) => (props.mw599 ? props.mw599 : "")};
      
}

`
const S2_Partners = () => {
    return (
        <div>
            <SectionWrapper p="6.5rem 0">
                <Container maxWidth="xl">
                    <Grid container justifyContent="center" spacing={3} >
                        <SectionHeading p="10px 0 40px" align="center" data-aos="zoom-in"
                            data-aos-delay="300"
                            data-aos-offset="0"
                            data-aos-duration="1000">Blockchains We Support</SectionHeading>
                        <Grid item xs={6} sm={4} md={2.3}>
                            <PartnerWrapper>
                                <div data-aos="zoom-in"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="400"
                                    data-aos-offset="0"
                                    data-aos-duration="500">
                                    <ParnterImg src={ethmainnet} />
                                </div>
                            </PartnerWrapper>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2.3}>
                            <PartnerWrapper>
                                <div data-aos="zoom-in"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="600"
                                    data-aos-offset="0"
                                    data-aos-duration="500">
                                    <ParnterImg src={shibarium} />
                                </div>
                            </PartnerWrapper>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2.3}>
                            <PartnerWrapper>
                                <div data-aos="zoom-in"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="800"
                                    data-aos-offset="0"
                                    data-aos-duration="500">
                                    <ParnterImg src={binance} />
                                </div>
                            </PartnerWrapper>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2.3}>
                            <PartnerWrapper>
                                <div data-aos="zoom-in"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="1000"
                                    data-aos-offset="0"
                                    data-aos-duration="500">
                                    <ParnterImg mw599="110px" src={polygon} />
                                </div>
                            </PartnerWrapper>
                        </Grid>
                        <Grid item xs={6} sm={4} md={2.3}>
                            <PartnerWrapper>
                                <div data-aos="zoom-in"
                                    data-aos-easing="ease-in"
                                    data-aos-delay="1200"
                                    data-aos-offset="0"
                                    data-aos-duration="500">
                                    <ParnterImg src={avalaunche} />
                                </div>
                            </PartnerWrapper>
                        </Grid>


                    </Grid>
                </Container>
            </SectionWrapper>
        </div>
    )
}

export default S2_Partners